import blueimpMd5 from 'blueimp-md5';
/**
 * Stable, opaque content key derived from an article URL — so the same article
 * maps to one catalogue document (and one recommender item) regardless of the
 * query string/casing the caller passes. Thin wrapper over `blueimp-md5`
 * (zero-dependency, UTF-8 safe). MD5 is used purely as a non-cryptographic
 * content hash; no security property is relied upon.
 */
export function md5(input) {
    return blueimpMd5(input);
}
